<template>
  <div class="card mb-25 border-0 rounded-0 bg-white letter-spacing">
    <div
      class="card-head box-shadow bg-white d-lg-flex align-items-center justify-content-between p-15 p-sm-20 p-md-25"
    >
      <div class="d-sm-flex align-items-center">
        <!-- <button
          class="default-outline-btn position-relative transition fw-medium text-black pt-10 pb-10 ps-25 pe-25 pt-md-11 pb-md-11 ps-md-30 pe-md-30 rounded-1 bg-transparent fs-md-15 fs-lg-16 d-inline-block mb-10 mb-lg-0"
          type="button"
        >
          Exporter
          <i class="flaticon-file-1 position-relative ms-5 top-2 fs-15"></i>
        </button> -->
      </div>
      <div class="d-flex align-items-center">
        <form class="search-box position-relative me-15" @submit.prevent="rechercher">
          <input
            type="text"
            v-model="searchTerm"
            @keyup="rechercher"
            class="form-control shadow-none text-black rounded-0 border-0"
            placeholder="Rechercher un bureau"
          />
          <button
            type="submit"
            class="bg-transparent text-primary transition p-0 border-0"
          >
            <i class="flaticon-search-interface-symbol"></i>
          </button>
        </form>
        <!-- <button
          class="dot-btn lh-1 position-relative top-3 bg-transparent border-0 shadow-none p-0 transition d-inline-block"
          type="button"
        >
          <i class="flaticon-dots"></i>
        </button> -->
      </div>
    </div>
    <div class="card-body p-15 p-sm-20 p-md-25">
      <div class="table-responsive">
        <table class="table text-nowrap align-middle mb-0">
          <thead>
            <tr>
              <th
                scope="col"
                class="text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0"
              >
                ID
              </th>
              <th
                scope="col"
                class="text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0"
              >
                NOM D'UTILISATEUR
              </th>
              <th
                scope="col"
                class="text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0"
              >
                OPERATION
              </th>
              <th
                scope="col"
                class="text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0"
              >
                DATE
              </th>
              <th
                scope="col"
                class="text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0"
              >
                ADRESSE MAC
              </th>
              <th
                scope="col"
                class="text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0"
              >
                ADRESSE IP
              </th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(jou , index) in journals" :key="index">
              <td class="shadow-none lh-1 fw-medium text-black-emphasis">
                {{ jou.entityId}}
              </td>
              <td class="shadow-none lh-1 fw-medium text-primary">
                {{ jou.userName}}
              </td>
              <td class="shadow-none lh-1 fw-medium text-black-emphasis">
                {{ jou.action}}
              </td>
              <td class="shadow-none lh-1 fw-medium text-black-emphasis">
                {{ format_date(jou.createdAt) }}
              </td>
              <td class="shadow-none lh-1 fw-medium text-black-emphasis">
                {{ (jou.addressMac) ? jou.addressMac : ''}}
              </td>
              <td class="shadow-none lh-1 fw-medium text-black-emphasis">
                {{ (jou.addressIP) ? jou.addressIP : ''}}
              </td>
            </tr>
          </tbody>
        </table>
      </div>
      <div
        class="pagination-area d-md-flex mt-15 mt-sm-20 mt-md-25 justify-content-between align-items-center"
      >
        <PaginationComponent :page="page" :totalPages="totalPages" :totalElements="totalElements" :limit="limit" @paginate="handlePaginate" />

      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent, onMounted, ref, watch } from "vue";
import { JournalConnexion } from "@/models/JournalConnexion";
import ApiService from "@/services/ApiService";
import  Swal  from "sweetalert2";
import { format_date, showModal, suppression, error } from "../../utils/utils";
import PaginationComponent from '@/components/Utilities/Pagination.vue';
import JwtService from "@/services/JwtService";

export default defineComponent({
    name: "ListeBureau",
    components: {
      PaginationComponent
  },
  setup: () => {
    const journals = ref<Array<JournalConnexion>>([]);
    const selectedItem = ref(0);

    // BEGIN PAGINATE
    const searchTerm = ref('');
    const page = ref(1);
    const totalPages = ref(0);
    const limit = ref(10);
    const totalElements = ref(0);

    const handlePaginate = ({ page_, limit_ }) => {
      try {
        page.value = page_;
        getAllJournalConnexion(page_, limit_);
      } catch (error) {
        //
        
      }
    };
    function rechercher(){
      getAllJournalConnexion(page.value, limit.value, searchTerm.value );
    }
    // END PAGINATE
    
    const recharger = () => {
      getAllJournalConnexion();
    };

    const show_Modal = (el) => {
      showModal(el);
      selectedItem.value = 0;
    };

    const editBureau = (id: number) => {
      selectedItem.value = id;
    };

    

    function getAllJournalConnexion(page = 1, limi = 10, searchTerm = '') {
      return ApiService.get(`/journalConnexions?page=${page}&limit=${limi}&mot=${searchTerm}&`)
      .then(( {data} ) => {
        (data)
        const donnees = data.data.data;
        journals.value = donnees;
        totalPages.value = data.data.totalPages;
        limit.value = data.data.limit;
        totalElements.value = data.data.totalElements;
      })
      .catch(({ response }) => {
        error(response.data.message)
      });
    }

    const privileges = ref<Array<string>>(JwtService.getPrivilege());

      const checkPermission = (name) => {
    return privileges.value.includes(name);
  }

    onMounted(() => {
      getAllJournalConnexion();
    });

    return { 
      checkPermission,
      journals,
      format_date,
      recharger,
      show_Modal,
      editBureau,
      selectedItem ,
      suppression,
      page, 
      totalPages,
      limit,
      totalElements,
      handlePaginate,
      searchTerm,
      rechercher
    };
  },
  
});
</script>